export default {
  title: '职位地点管理',
  menu: '职位地点管理',
  label: {
    companyName: '公司名称',
    city: '城市',
    region: '区',
    cbd: '商圈',
    address: '详细地址',
    status: '状态',
    active: '有效',
    inactive: '无效',
    excelInput: 'EXCEL文件: ',
    uploadLocation: '审核上传地址',
    addLocation: '添加地址',
    editLocation: '编辑地址'
  },
  btn: {
    addLocation: '添加地点',
    batchUpload: '批量上传',
    selectFile: '浏览',
    upload: '上传前员工',
    downloadTemplate: '下载模板',
    cancelUpload: '取消',
    ConfirmUpload: '确认',
    remove: '移除'
  },
  placeholder: {
    city: '请选择城市',
    status: '请选择状态',
    search: '关键词搜索'
  },
  message: {
    uploadTip: '只能上传excel文件',
    uploadError: '上传失败,请重新上传',
    uploadSuccess: '上传{totalCount}个地址，有{failedCount}个和已有地址重复',
    locationIsExisted: '该地址已存在，请重新设置地址！',
    removeLocation: '您确定要移除{cityName} - {address}吗？',
    notAllMatchedGEO: '请确保所有的地点都匹配到正确的地理位置, 区和商圈。',
    disableLocation: '{address} 此地点将会从现有的包含此地点的职位中删除，继续吗？',
    onlyLocationTip: '职位{locationIds}只有这个地点。在禁用此地点前，请先关闭的这些职位。'
  }
}
